module.exports = __webpack_public_path__ + "react.23zQdRvn.svg";